import React from "react";
import styles from "./Header.module.css";
import yukonLogo from "../../../assets/images/yukon-logo.png";
import { Link } from "react-router-dom";

import { useReviewContext } from '../../../context/ReviewContext';
import useNavigationGuard from '../../../hooks/useNavigationGuard';
import ReviewExitDialog from "../dialog/reviewExitDialog/ReviewExitDialog";
import Profile from "../../auth/Profile";


const Header = ({ page }) => {
  const { shouldBlockNavigation, reviewerProfileData } = useReviewContext();

  const {
    showDialog,
    handleNavigationAttempt,
    handleConfirm,
    handleCancel } = useNavigationGuard(shouldBlockNavigation);

  const handleLogoClick = (e) => {
    e.preventDefault();
    handleNavigationAttempt('/dashboard');
  };

  return (
    <header className={styles.header}>
      <Link
        to="/dashboard"
        className={styles['link']}
        onClick={(e) => handleLogoClick(e)}
      >
        <img
          src={yukonLogo}
          alt="Yukon Logo"
          className={styles["logo"]}
          style={{ cursor: 'pointer' }}
        />
      </Link>

      {(page !== 'login') &&
        <Profile reviewerProfileData={reviewerProfileData} />}

      <ReviewExitDialog
        isOpen={showDialog}
        onClose={handleCancel}
        onConfirm={handleConfirm}
      />
    </header>
  );
};

export default Header;